

  const firebaseConfig = {
    apiKey: "AIzaSyAqH7FizP3vo5Pmz126ncTG0IFgWCU4v7k",
    authDomain: "mygitapp-b6c5d.firebaseapp.com",
    projectId: "mygitapp-b6c5d",
    storageBucket: "mygitapp-b6c5d.appspot.com",
    messagingSenderId: "816359332059",
    appId: "1:816359332059:web:1fb16605910625401f14fe",
    measurementId: "G-V0GQB7JQ7F"
  };
  export default firebaseConfig
  
